import axios, { AxiosInstance, AxiosError } from 'axios';
import { authErrorHandler } from '@/utils/authErrorHandler';

// Create axios instance with default configuration
const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  withCredentials: true, // Important for cookie-based authentication
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token if available
apiClient.interceptors.request.use(
  (config) => {
    // You can add authorization header here if you store token in localStorage
    // const token = localStorage.getItem('authToken');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access by clearing auth and redirecting to login
      const currentPath = window.location.pathname + window.location.search;
      authErrorHandler.handle401Error(currentPath);
    }
    return Promise.reject(error);
  }
);

// Helper function to create form data for URL encoded requests
export const createFormData = (data: Record<string, string | number | boolean>): URLSearchParams => {
  const formData = new URLSearchParams();
  Object.keys(data).forEach(key => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, String(data[key]));
    }
  });
  return formData;
};

// Export configured client
export default apiClient;

// Export common error handler
export const handleApiError = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.detail) {
      return error.response.data.detail;
    }
    if (error.response?.status === 404) {
      return 'Resource not found';
    }
    if (error.response?.status === 500) {
      return 'Server error. Please try again later.';
    }
    if (error.message) {
      return error.message;
    }
  }
  return 'An unexpected error occurred';
};